/**
 * Diz se o PUT de permissões deve ser evitado para um vínculo.
 *
 * O backend responde 403 em dois casos (ver `AtualizarPermissoesResponsavel`):
 * o alvo é o próprio usuário logado — evita auto-escalação — ou o vínculo é de
 * coordenador (`Fixo`), cujas permissões vêm da coordenação.
 *
 * Cargo e contato continuam editáveis nos dois casos. Como o salvamento faz o
 * PUT de cargo/contato antes do de permissões, tentar o segundo quando ele é
 * proibido grava o cargo e depois estoura — a tela acusa "erro ao salvar" com o
 * dado já salvo, e o usuário só vê a mudança após recarregar a página.
 *
 * Não confundir com o `permissoesTravadas` do EditarResponsavelModal: aquele
 * decide o que **desabilitar na interface** e trava mais casos por UX (cargo
 * "coordenador", coordenadorPadrao). Este decide se **vale fazer a requisição**,
 * então espelha exatamente o que o backend recusa — nem mais, nem menos.
 *
 * A comparação ignora caixa porque GUID não é sensível a ela; `idsIguais`, de
 * utils/ids, compara de forma sensível e por isso não serve aqui.
 */
export function permissoesTravadas(alvo, usuarioLogado) {
  if (alvo?.fixo) return true;

  const idAlvo = alvo?.userId;
  const idLogado = usuarioLogado?.id;
  if (!idAlvo || !idLogado) return false;

  // GUID não é sensível a caixa: o mesmo id pode chegar em grafias diferentes.
  return String(idAlvo).toLowerCase() === String(idLogado).toLowerCase();
}
